import { Button, InputNumber, Popover, Space } from 'antd'
import { useRef, useState } from 'react'
import { calculateUsageQuantity } from '../../domain/productionRate'
import Units from './Units'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalculator, faRight } from '@fortawesome/pro-solid-svg-icons'

export type RateCalculationData = {
  name: string
  units: string
  rateInstallationQuantity: number
  ratePerUnits: string
  rateUsageQuantity: number
}

export type Props = {
  disabled?: boolean
  data?: RateCalculationData
  onSubmit: (quantity: number) => void
}

const RateCalculator = ({ data, onSubmit, disabled }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const [installationQuantity, setInstallationQuantity] = useState(0)
  const ref = useRef<any>()

  const name = data?.name ?? ''
  const ratePerUnits = data?.ratePerUnits ?? ''
  const units = data?.units ?? ''
  const rateInstallationQuantity = data?.rateInstallationQuantity ?? 0
  const rateUsageQuantity = data?.rateUsageQuantity ?? 0
  const calculated = calculateUsageQuantity(installationQuantity, rateInstallationQuantity, rateUsageQuantity)

  const changeIsOpen = (newValue: boolean) => {
    if (!isOpen && newValue) {
      setTimeout(() => ref.current?.select(), 1)
    }
    setIsOpen(newValue)
  }

  const handleSubmit = () => {
    changeIsOpen(false)
    onSubmit(calculated)
  }

  const inputStyle = { width: '150px' }

  const popoverContent = <Space direction="vertical" size="middle">
    <span>Installation Rate: {rateInstallationQuantity} {ratePerUnits} per {rateUsageQuantity} {units}</span>
    <Space size="large">
      <InputNumber
        ref={ref}
        value={installationQuantity}
        addonAfter={<Units width={40} fontSize={11} units={ratePerUnits} />}
        onChange={value => setInstallationQuantity(value ?? 0)}
        min={0}
        onPressEnter={handleSubmit}
        style={inputStyle}
      />
      <FontAwesomeIcon icon={faRight} />
      <InputNumber
        value={calculated}
        addonAfter={<Units width={40} fontSize={11} units={units} />}
        disabled
        style={inputStyle}
      />
    </Space>
    <Space style={{ justifyContent: 'flex-end', width: '100%' }}>
      <Button onClick={() => changeIsOpen(false)}>Cancel</Button>
      <Button type="primary" onClick={handleSubmit}>Update</Button>
    </Space>
  </Space>

  return <Popover
    content={popoverContent}
    title={`Production Rate for ${name}`}
    open={isOpen}
    onOpenChange={x => changeIsOpen(x && data !== undefined && !disabled)}
    trigger="click"
  >
    <Button tabIndex={-1} disabled={!data || disabled}><FontAwesomeIcon icon={faCalculator} /></Button>
  </Popover>
}
export default RateCalculator
